import { render, staticRenderFns } from "./liveview.vue?vue&type=template&id=0b882884&scoped=true&lang=pug&"
import script from "./liveview.vue?vue&type=script&lang=js&"
export * from "./liveview.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=0b882884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b882884",
  null
  
)

export default component.exports